interface Ifoot {
  apiData: any;
}

const getTotal = (apiData: any) => {
  let output = [];
  let totalSum = 0;
  for (let i = 0; i < 21; i++) {
    let sum = 0;
    for (const partName in apiData) {
      sum += apiData[partName][i];
    }
    totalSum += sum;
    output.push(<th>{sum}</th>);
  }
  output.push(<th>{totalSum}</th>);
  return output;
};
const TFoot = ({ apiData }: Ifoot) => {
  return (
    <tfoot>
      <tr style={{ background: 'yellow' }}>
        <th colSpan={2}>Total</th>
        {getTotal(apiData)}
      </tr>
    </tfoot>
  );
};

export default TFoot;
